import React from "react";
import RowCardItem from "../shared/row-card-item/RowCardItem";
import WordBookMarkedListState, { WordBookMarkedListProps } from "./WordBookMarkedList.models";
import bookMarkImage from '../../assest/images/card-image/bookMark.png'
import './WordBookMarkedList.scss';
import FlashCardBookmark from "../../services/content/FlashCardBookmark";

export default class WordBookMarkedList extends React.PureComponent<WordBookMarkedListProps, WordBookMarkedListState> {
    flashCardBookmark: FlashCardBookmark;
    constructor(props: WordBookMarkedListProps) {
        super(props);
        this.flashCardBookmark = new FlashCardBookmark()
        this.state = { boxId: '', bookmarkedWords: [] };
    }

    componentDidMount = () => {
        if (this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    componentDidUpdate = (prevProps: WordBookMarkedListProps) => {
        if (prevProps.boxId !== this.props.boxId && this.props.boxId !== null && this.props.boxId !== undefined) {
            this.setState({ boxId: this.props.boxId });
            this.getPaged();
        }
    }

    getPaged = () => {
        let state = this;
        this.flashCardBookmark.getPaged(this.props.boxId as string).then(response => {
            state.setState({ bookmarkedWords: response });
        })
    }

    render(): React.ReactNode {
        let { bookmarkedWords } = this.state;
        return <>
            <div className="dropdown-list word-book-marked-list" >
                {bookmarkedWords.map((word, key) => {
                    return <RowCardItem imageSource={bookMarkImage} title={word.title} subTitle="" key={key} />
                })}
            </div>
        </>
    }
}